import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 900,
    },
    fieldWrapper: {
      border: `1px dotted ${theme.palette.grey[500]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
      width: "100%",
      "& + $fieldWrapper": {
        marginTop: theme.spacing(3),
      },
    },
    fieldLabel: {
      borderBottom: `1px dotted ${theme.palette.grey[400]}`,
      display: "block",
      marginBottom: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    formWrapper: {
      position: "relative",
      "& .vo-global__content-with-toolbar": {
        // boxShadow: "none",
        // padding: 0,
        marginTop: theme.spacing(2),
      },
      "& .vo-global__content-toolbar": {
        borderRadius: theme.shape.borderRadius,
        // padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        marginTop: theme.spacing(10.5),
        position: "relative",
        left: "auto",
        right: "auto",
        top: "auto",
        zIndex: 2,
      },
    },
    // dialog: {
    //   maxWidth: "90vw",
    //   maxHeight: "90vh",
    //   minHeight: "70vh",
    //   width: "100%",
    //   [theme.breakpoints.up("lg")]: {
    //     maxWidth: 800,
    //   },
    //   [theme.breakpoints.down("sm")]: {
    //     maxWidth: "98vw",
    //   },
    //   // "&$loading": {
    //   //   background: "none",
    //   //   boxShadow: "none",
    //   // },
    //   "& .vo-global__content-with-toolbar": {
    //     boxShadow: "none",
    //     padding: 0,
    //   },
    //   "& .vo-global__content-toolbar": {
    //     padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    //     position: "absolute",
    //     left: 0,
    //     right: 0,
    //     top: 0,
    //     zIndex: 2,
    //   },
    // },
  })
);
